import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  name: 'LoadingSpinner',
})
export default class LoadingSpinner extends Vue {}
